import {
  CreateBusinessUnitTradeMappingsRequest,
  CreateBusinessUnitTradeMappingsResponse,
} from "./types";
import axiosInstance from "../axiosInstance";

export const createBusinessUnitTradeMappings = async (
  companyUuid: string,
  request: CreateBusinessUnitTradeMappingsRequest,
): Promise<CreateBusinessUnitTradeMappingsResponse> => {
  const response =
    await axiosInstance.post<CreateBusinessUnitTradeMappingsResponse>(
      `/api/private/companies/${companyUuid}/service-titan/business-units/trade-mappings`,
      request,
    );
  return response.data;
};
